/**
 * Admin sidebar — intent-based sections (collapsible).
 * Routes only; no page rewrites. English UI labels.
 */

const menu = [
  {
    icon: "dashboard",
    text: "Dashboard",
    link: "/",
    dashboard: true,
  },
  {
    icon: "alert-circle",
    text: "Needs attention",
    link: "#",
    section: true,
    defaultOpen: true,
    sectionId: "attention",
    subMenu: [
      {
        icon: "user-check",
        text: "Practitioners to verify",
        link: "/teleconsultations/practitioner-approvals",
        countKey: "practitioners",
      },
      {
        icon: "file-text",
        text: "Second opinion to assign",
        link: "/second-opinion/cases",
        countKey: "soAssign",
      },
      {
        icon: "article",
        text: "Quote requests",
        link: "/user-quotes",
        countKey: "quotes",
      },
      {
        icon: "msg",
        text: "Partner support",
        link: "/teleconsultations/support-requests",
      },
      {
        icon: "mail",
        text: "Contact & leads",
        link: "#",
        subMenu: [
          { text: "Contact form", link: "/contact-form", icon: "article" },
          { text: "Partner leads", link: "/partner-leads", icon: "article" },
          { text: "Lead circles", link: "/lead-circles", icon: "circle" },
        ],
      },
    ],
  },
  {
    icon: "folder",
    text: "Directory",
    link: "#",
    section: true,
    defaultOpen: false,
    sectionId: "directory",
    subMenu: [
      { icon: "plus-medi", text: "Medical partners", link: "/medical-partner" },
      { icon: "home", text: "Clinics", link: "/clinics" },
      { icon: "user-check", text: "Practitioners", link: "/practitioners" },
      { icon: "user", text: "Patients", link: "/user-list-compact?role=client" },
      { icon: "users", text: "Team", link: "/user-list-compact?team=1" },
      { icon: "building", text: "Enterprises", link: "/enterprise" },
      { icon: "users", text: "Employees", link: "/employee" },
      { icon: "user", text: "Brokers", link: "/broker" },
      { icon: "user-list", text: "Second opinion experts", link: "/second-opinion/experts" },
    ],
  },
  {
    icon: "activity",
    text: "Activity",
    link: "#",
    section: true,
    defaultOpen: false,
    sectionId: "activity",
    subMenu: [
      { icon: "calendar", text: "Video consultations", link: "/teleconsultations" },
      { icon: "file-text", text: "Second opinion cases", link: "/second-opinion/cases" },
      { icon: "tag", text: "Second opinion offers", link: "/second-opinion/offers" },
      { icon: "article", text: "Quotes & matching", link: "/user-quotes" },
      { icon: "growth", text: "Operations", link: "/teleconsultations/operations" },
      { icon: "file-docs", text: "Reports", link: "/reports" },
    ],
  },
  {
    icon: "coins",
    text: "Finance",
    link: "#",
    section: true,
    defaultOpen: false,
    sectionId: "finance",
    subMenu: [
      {
        icon: "file-docs",
        text: "Invoices",
        link: "/invoice-list",
        requirePermission: "finance.invoices.view",
      },
      {
        icon: "calc",
        text: "Partner prices",
        link: "/partner-prices",
        requirePermission: "finance.partner_prices.view",
      },
    ],
  },
  {
    icon: "setting",
    text: "Configuration",
    link: "#",
    section: true,
    defaultOpen: false,
    muted: true,
    sectionId: "config",
    subMenu: [
      {
        icon: "calc",
        text: "Medical specialties",
        link: "/specialty-list",
        requirePermission: "content.specialties.view",
      },
      {
        icon: "grid-alt",
        text: "Catalog roots",
        link: "/platform-catalog-roots",
        requirePermission: "content.catalog_roots.view",
      },
      {
        icon: "view-col",
        text: "Services mega menu",
        link: "/teleconsultations/navigation-items",
        requirePermission: "content.navigation.view",
      },
      { icon: "layout-alt", text: "Clinic landing content", link: "/my-clinics" },
      {
        icon: "img",
        text: "Media library",
        link: "/media-library",
        requirePermission: "content.media.view",
      },
      {
        icon: "file-docs",
        text: "Country regulations",
        link: "/prescription-regulations",
        requirePermission: "technique.regulations.view",
      },
      {
        icon: "text-rich",
        text: "Email",
        link: "/email-templates-management",
        requirePermission: "technique.email_templates.view",
      },
      {
        icon: "setting",
        text: "Settings",
        link: "/admin-settings",
        requirePermission: "technique.settings.view",
      },
      {
        icon: "users",
        text: "Admins & permissions",
        link: "/rbac-admins",
        requirePermission: "admin.manage",
      },
      {
        icon: "account-setting",
        text: "Roles",
        link: "/rbac-roles",
        requirePermission: "admin.manage",
      },
      {
        icon: "file-text",
        text: "Audit log",
        link: "/rbac-audit",
        requirePermission: "admin.manage",
      },
    ],
  },
];

export default menu;
